/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, OnInit} from '@angular/core';

import {AuthService, I18nService, RemovalService, ThirdPartyService} from '../../_services/services';
import {Removal, ThirdParty} from '../../_models/models';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import {Helpers} from '../../helpers';
import {DEFAULT, EMBEDDED} from '../../_enums/serializer-groups';
import {AND, EQ} from '../../_enums/operators';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PROPERTIES                                                                                            ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public removals: Removal[] = [];

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(
    private authService: AuthService,
    private i18n: I18nService,
    private removalService: RemovalService,
    private thirdPartyService: ThirdPartyService,
    private toastr: ToastrService
  ) {
  }

  ngOnInit() {
    // This is intentional
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PRIVATE METHODS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public loadPendingRemovals(thirdParties: ThirdParty[]): void {
    this.removals = [];

    Helpers.setLoading(true);

    thirdParties.forEach((v: ThirdParty) => {
      this.removalService.find({
        filter: [['thirdParty', EQ, v.id], AND, ['validated', EQ, false]],
        serializerGroups: [DEFAULT, EMBEDDED]
      }).subscribe((res: HttpResponse<Removal[]>) => {
        this.removals = this.removals.concat(res.body);
      }, (err: HttpErrorResponse) => {
        this.handleError(err);
      }, () => {
        Helpers.setLoading(false);
      });
    });
  }

  private handleError(err: HttpErrorResponse): void {
    Helpers.setLoading(false);
    this.toastr.error(`${err.status} - ${this.i18n.get(err.status)}`);
  }

}
